import React, { useEffect, useState } from 'react';
import { getPlatformTenant, getHVAObjectList, getAllUsers, getTenantById } from '../../services/reportServices';
import { getTenantEmailBodyTemplates, getReportNotificationListByUser, getReportNotificationsIAmMemberOf, addReportNotification, updateReportNotification,deleteReportNotification,updatePropertiesReportNotification,updateReportNotificationObjectFilters,subscribeReportNotification,unsubscribeReportNotification } from '../../services/reportNotificationService';
import powerBISettings from '../../configs/powerBISettings';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import {Typography, Box, Tooltip, Link } from '@mui/material';
import { useGridApiRef, DataGridPremium } from "@mui/x-data-grid-premium";
import InDataGridContainer from '../grid/InDataGridContainer'
import { v4 as uuidv4 } from 'uuid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import SubscriptionMgt from './SubscriptionMgt';
import ScheduleViewDialog from "./ScheduleViewDialog";
import ConfigureContentPack from './ConfigureContentPack'; 
import {Alert,Snackbar,Button } from '@mui/material';

function SubscriptionMgtMain(props) {
const { isAuthenticated, userType, selectedTenant, accessToken, powerBIAccessTokenTime, rlsUser, userId, privileges,resetSessionTimer } = props;
const[loginUserId, setLoginUserId] = useState(null);
const [userTenantAccessMappingExisting, setUserTenantAccessMappingExisting] = useState(null);
const [selectedUserId, setSelectedUserId] = useState(null);
const [disableUserList, setDisableUserList] = useState(true);
const [selectedTenantId, setSelectedTenantId] = useState(null);
const [disableReportNotificationTypeList, setDisableReportNotificationTypeList] = useState(true);
const [showNewNotificationLink, setShowNewNotificationLink] = useState(false);
const [showReportNotifications, setShowReportNotifications] = useState(false);
const [reportNotifications, setReportNotifications] = useState([]);
const [reportNotificationCollection, setReportNotificationCollection] = useState([]);
const [tenantEmailBodyTemplates, setTenantEmailBodyTemplates] = useState([]);
const [showUsers, setShowUsers] = useState(false);
const [HvaObjects, setHvaObjects] = useState([]);
const [reportList, setReportList] = useState([]);
const [selectedObjectId, setSelectedObjectId] = useState("");
const [users, setUsers] = useState([]);
const [currentUserEmailId, setCurrentUserEmailId] = useState("");
const [disableFeatureList, setDisableFeatureList] = useState(true);
const [isServiceOrTenantAdminOrSupportImpUser, setIsServiceOrTenantAdminOrSupportImpUser] = useState(false);
const [notifications, setNotifications] = useState(powerBISettings.ReportNotificationViewTypes || []);
const [openSchedulePopup, setOpenSchedulePopup] = useState(false);
const [selectedScheduleRow, setSelectedScheduleRow] = useState(null);
const [openConfigureDialog, setOpenConfigureDialog] = useState(false);  
const [selectedSubscription, setSelectedSubscription] = useState(null);  
const [subscribeAlert, setSubscribeAlert] = useState({  
  open: false,  
  message: '',  
  severity: 'success'  
});

const getNotificationValue = (notification, idx) =>
  notification.id !== undefined && notification.id !== null ? String(notification.id) : String(idx);

const [selectedNotification, setSelectedNotification] = useState(
  notifications.length > 0 ? getNotificationValue(notifications[0], 0) : ''
);
const [selectedReportNotificationTypeId, setSelectedReportNotificationTypeId] = useState("0");
const [isReportNotificationTypeSelected, setIsReportNotificationTypeSelected] = useState(false);
const [loading, setLoading] = useState(false);
const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
const apiRef = useGridApiRef();
const [tempUsers, setTempUsers] = useState([]);
const [newReportNotificationObject, setNewReportNotificationObject] = useState(null);
const [objectName, setObjectName] = useState("");
const [subcriptionMgtActionType, setSubcriptionMgtActionType] = useState("add");
const columns = [
  { field: 'DisplayName', headerName: 'Display Name', flex: 1, minWidth: 150, editable: false },
  { field: 'FeatureName', headerName: 'Content Pack', flex: 1, minWidth: 180, editable: false },
  { field: 'ReportFormat', headerName: 'Report Format', flex: 1, minWidth: 120, editable: false },
  { field: 'CreatedBy', headerName: 'Created By', flex: 1, minWidth: 200, editable: false },
  { field: 'CreatedDate', headerName: 'Creation Date', flex: 1, minWidth: 180, editable: false },
  { field: 'LastModifiedBy', headerName: 'Updated By', flex: 1, minWidth: 200, editable: false },
  { field: 'LastModifiedDate', headerName: 'Updated Date', flex: 1, minWidth: 180, editable: false },
  { field: 'popupview', headerName: 'View Schedule', displayName:'View', flex: 1, minWidth: 120, sortable: false, type: "popupview", editable: false},
  { field: 'ToEmailAddresses', headerName: 'Configured Subscribers', flex: 1, minWidth: 200, editable: false },
  { field: 'actions', headerName: 'Actions', displayName:'Subscription', actions: 'edit, manage, subscribe, unsubscribe, delete', width: 150, editable: false },

];
useEffect(() => {
  if(isAuthenticated)
  {
    if(props.isSupportImplUser || props.isServiceAdmin)
    {
      setSelectedNotification("0");
      setIsReportNotificationTypeSelected(false);
      // Common logic for Support Implementation User and Service Admin
      setLoginUserId(parseInt(userId));
      setUserTenantAccessMappingExisting(userType.userTenantAccessMappingExisting);
      setSelectedUserId(userType.userId);
      if(selectedTenant && selectedTenant !== "Select Tenant"){
        setSelectedTenantId(selectedTenant);
        getUserList(selectedTenant); 
      }
      else{
        setDisableReportNotificationTypeList(true);
        setShowNewNotificationLink(false);
        return;
      }
      if(props.isServiceAdmin){
        GetPlatformTenant();
      }
    }
     else if (
      props.isTenantAdmin 
    ) {
      setDisableUserList(false);
      setSelectedTenantId(userType.tenantId);
      setSelectedUserId(userType.userId);
      getTenantInfoById(userType.tenantId);
      getProductFeatureListOfUser(null,userType.tenantId);
      loadUsers(userType.tenantId);
      GetTenantEmailBodyTemplates(userType.tenantId);
    }
    else{
      setSelectedTenantId(userType.tenantId);
      setSelectedUserId(userType.userId);
      setDisableReportNotificationTypeList(false);
      setShowNewNotificationLink(true);
      setDisableFeatureList(false);
      getTenantInfoById(userType.tenantId);
      getProductFeatureListOfUser(null,userType.tenantId);
      loadUsers(userType.tenantId);
      GetTenantEmailBodyTemplates(userType.tenantId);
    }
    if (props.isServiceAdmin || props.isTenantAdmin || props.isSupportImplUser)
      setIsServiceOrTenantAdminOrSupportImpUser(true);
  }
}, [isAuthenticated, selectedTenant, props.isServiceAdmin, props.isSupportImplUser, props.isTenantAdmin, userId, userType]);

const GetPlatformTenant = async () => {
    setShowReportNotifications(true);
    setReportNotifications([]);
    setReportNotificationCollection([]);
    setTenantEmailBodyTemplates([]);
    setShowUsers(true);

    try {
      const result = await getPlatformTenant(); // You need to implement this in your service
      if (result.data) {
        setShowReportNotifications(true);
        setReportNotifications(result.data.ReportNotifications);
        setReportNotificationCollection([...result.data.ReportNotifications]);
        setTenantEmailBodyTemplates(result.data.EMailBodyTemplates);
         const { notifications, notificationCollection } = getFeatureName(
        result.data.ReportNotifications,
        [...result.data.ReportNotifications],
        HvaObjects
      );
        
      }
    } catch (error) {
      // Show error message
      // ErrorMessageUtility.ShowErrorMessage(error);
      console.error(error);
    }
  };

const getFeatureName = (notifications, notificationCollection, hvaObjects) => {
  if (!notifications || !notificationCollection || !hvaObjects) return { notifications, notificationCollection };
  const updatedNotifications = notifications.map((notif, i) => {
    const hvaObject = hvaObjects.filter(e => e.ObjectId === notif.ObjectId);
    if (hvaObject.length > 0) {
      let objectName = hvaObject[0].ObjectDisplayName;
      
      let featureVersion = hvaObject[0].Version;
      setObjectName(objectName + ' ' + featureVersion);
      notif["FeatureName"] = objectName + ' ' + featureVersion;
    } else {
      notif["FeatureName"] = notif.ccEmailAddresses || notif.CcEmailAddresses;
    }
    return notif;
  });
  const updatedCollection = notificationCollection.map((notif, i) => {
    const hvaObject = hvaObjects.filter(e => e.ObjectId === notif.ObjectId);
    if (hvaObject.length > 0) {
      let objectName = hvaObject[0].ObjectDisplayName;
      
      let featureVersion = hvaObject[0].Version;
      setObjectName(objectName + ' ' + featureVersion);
      notif["FeatureName"] = objectName + ' ' + featureVersion;
    } else {
      notif["FeatureName"] = notif.ccEmailAddresses || notif.CcEmailAddresses;
    }
    return notif;
  });
  return { notifications: updatedNotifications, notificationCollection: updatedCollection };
};

const getUserList = async (tenantId) => {
  setShowReportNotifications(false);
  setSelectedObjectId("");
  setUsers([]);
  setHvaObjects([]);
  setReportNotifications([]);
  setReportNotificationCollection([]);
  // If you have a disableFeatureList state, set it here
  setDisableUserList(true);
  setDisableReportNotificationTypeList(true);
  setShowNewNotificationLink(false);

  if (tenantId != null && tenantId !== "") {
    // If you have Tenants state, you can filter here
    // const tenant = Tenants.filter(e => e.TenantId === tenantId);
    await getProductFeatureListOfUser(null, tenantId);
    await loadUsers(tenantId);
    await getTenantInfoById(tenantId);
    await GetTenantEmailBodyTemplates(tenantId);
  }
};

const getProductFeatureListOfUser = async (user, tenantIdParam) => {
  setHvaObjects([]);
  try {
    const tenantId = tenantIdParam || selectedTenantId;
    if (!tenantId) {
      console.error("No tenantId provided to getProductFeatureListOfUser");
      return;
    }
    const result = await getHVAObjectList(tenantId);
    if (result && result.data) {
      setReportList(result.data);
      const hvaObjects = [];
      result.data.forEach(report => {
        if (report.HVAObjectList && Array.isArray(report.HVAObjectList)) {
          report.HVAObjectList.forEach(obj => {
            hvaObjects.push(obj);
          });
        }
      });
      setHvaObjects(hvaObjects);
      setSelectedObjectId("");
    }
  } catch (error) {
    console.error("Error fetching HVA Object List:", error);
  }
};

const loadUsers = async (tenantIdParam) => {
  setUsers([]);
  setDisableUserList(false);
  setDisableReportNotificationTypeList(false);
  setShowNewNotificationLink(false);
  if(privileges.Manage || props.isServiceAdmin || props.isSupportImplUser) {
    setShowNewNotificationLink(true);
  }

  if (tenantIdParam === "" || tenantIdParam === undefined) {
    setDisableUserList(true);
    setDisableReportNotificationTypeList(true);
    setShowNewNotificationLink(false);
    return;
  }

  try {
    // If you want to use GetAllUsersByTenantId, replace getAllUsers below
    const result = await getAllUsers(tenantIdParam, true);
    const usersData = result.data || [];
    const processedUsers = usersData.map(user => {
      if (user.UserId === userId && user.UserDemographic) {
        setCurrentUserEmailId(user.UserDemographic.Email);
      }
      if (user.UserDemographic) {
        if (user.UserDemographic.FirstName == null) user.UserDemographic.FirstName = '';
        if (user.UserDemographic.LastName == null) user.UserDemographic.LastName = '';
        if (user.UserDemographic.FirstName === '' && user.UserDemographic.LastName === '') {
          user.UserDemographic.FirstName = user.UserPrincipalName;
        }
      } else {
        user.UserDemographic = { FirstName: user.UserPrincipalName };
      }
      return user;
    });
    setUsers(processedUsers);
  } catch (error) {
    console.error("Error loading users:", error);
  }
};

const getTenantInfoById = async (tenantIdParam) => {
  setShowReportNotifications(true);
  setReportNotifications([]);
  setReportNotificationCollection([]);
  setShowUsers(true);

  const tenantId = tenantIdParam || selectedTenantId;
  try {
    const result = await getTenantById(tenantId);
    if (result && result.data) {
      // Update notifications and collection with feature names
      setShowReportNotifications(true);
      let notificationsArray = Array.isArray(result.data.ReportNotifications) ? result.data.ReportNotifications : [];
      setReportNotifications(notificationsArray);
      const processedRows = notificationsArray.map(row => ({
        ...row,
        // Normalize field names to match grid column expectations  
        DisplayName: row.displayName || row.DisplayName,  
        CreatedBy: row.createdBy || row.CreatedBy,  
        CreatedDate: row.createdDate || row.CreatedDate,  
        LastModifiedBy: row.lastModifiedBy || row.LastModifiedBy,  
        LastModifiedDate: row.lastModifiedDate || row.LastModifiedDate,  
        ReportFormat: row.reportFormat || row.ReportFormat,
        ToEmailAddresses: row.toEmailAddresses || row.ToEmailAddresses, 
        Timezone: row.timezone || row.Timezone,  
        StartDate: row.startDate || row.StartDate,  
        EndDate: row.endDate || row.EndDate,  
        RecurrencePattern: row.recurrencePattern || row.RecurrencePattern,  
        RecurrencePatternDetails: row.recurrencePatternDetails || row.RecurrencePatternDetails,  
        SendReportTime: row.sendReportTime || row.SendReportTime,  
        NextRecurrenceDate: row.nextRecurrenceDate || row.NextRecurrenceDate, 
        id: row.subscriptionID ?? row.id ?? uuidv4() 
      }));
      setReportNotificationCollection(processedRows);
      const { notifications, notificationCollection } = getFeatureName(
        processedRows,
        [...processedRows],
        HvaObjects
      );
      setReportNotifications(notifications);
      setReportNotificationCollection(notificationCollection);
    }
  } catch (error) {
    // If you have an error message utility, use it here
    // ErrorMessageUtility.ShowErrorMessage(error);
    console.error("Error fetching tenant by ID:", error);
  }
  // If you need to fetch tenant email body templates, call that function here
  // getTenantEmailBodyTemplates();
};

const GetTenantEmailBodyTemplates = async (tenantIdParam) => {
  setTenantEmailBodyTemplates([]);
  try {
    const result = await getTenantEmailBodyTemplates(tenantIdParam);
    if (result && result.data) {
      setTenantEmailBodyTemplates(result.data);
    }
  } catch (error) {
    // If you have an error message utility, use it here
    // ErrorMessageUtility.ShowErrorMessage(error);
    console.error("Error fetching tenant email body templates:", error);
  }
};

// Rename local function to avoid naming conflict with imported service
const fetchReportNotificationsIAmMemberOf = async (tenantId, userId) => {
  setShowReportNotifications(true);
  setReportNotifications([]);
  setReportNotificationCollection([]);
  setShowUsers(true);
  try {
    // Call the imported service function
    const result = await getReportNotificationsIAmMemberOf(tenantId, userId);
    if (result && result.data && result.data.length !== 0) {
      setShowReportNotifications(true);
      setReportNotifications(result.data);
        const processedRows = result.data.map(row => ({  
        ...row,  
        // Normalize field names to match grid column expectations  
        DisplayName: row.displayName ?? row.DisplayName,  
        CreatedBy: row.createdBy ?? row.CreatedBy,  
        CreatedDate: row.createdDate ?? row.CreatedDate,  
        LastModifiedBy: row.lastModifiedBy ?? row.LastModifiedBy,  
        LastModifiedDate: row.lastModifiedDate ?? row.LastModifiedDate,  
        ReportFormat: row.reportFormat ?? row.ReportFormat,
        ToEmailAddresses: row.toEmailAddresses ?? row.ToEmailAddresses, 
        Timezone: row.timezone ?? row.Timezone,  
        StartDate: row.startDate ?? row.StartDate,  
        EndDate: row.endDate ?? row.EndDate,  
        RecurrencePattern: row.recurrencePattern ?? row.RecurrencePattern,  
        RecurrencePatternDetails: row.recurrencePatternDetails || row.RecurrencePatternDetails,  
        SendReportTime: row.sendReportTime || row.SendReportTime,  
        NextRecurrenceDate: row.nextRecurrenceDate || row.NextRecurrenceDate, 
        EmailBodyTemplate: row.emailBodyTemplate ?? row.EmailBodyTemplate,
        FullReport: row.fullReport ?? row.FullReport,
        TemplateId: row.templateId ?? row.TemplateId,
        TenantId: row.tenantId ?? row.TenantId,
        UserId: row.userId ?? row.UserId,
        SubscriptionID: row.subscriptionID ?? row.id ?? uuidv4(),
        Subject: row.subject ?? row.Subject,
        RLSUser: row.rlsUser ?? row.RlsUser,
        ReportShareType: row.reportShareType ?? row.ReportShareType,
        ReportPassword: row.reportPassword ?? row.ReportPassword,
        Properties: row.properties ?? row.Properties,
        ObjectId: row.objectId ?? row.ObjectId,
        LastDeliveryStatus: row.lastDeliveryStatus ?? row.LastDeliveryStatus,
        DeviceType: row.deviceType ?? row.DeviceType,
        id: row.subscriptionID ?? row.id ?? uuidv4()   
      }));
        setReportNotificationCollection(processedRows);
        const { notifications, notificationCollection } = getFeatureName(
          processedRows,
          [...processedRows],
          HvaObjects
        );
      setReportNotifications(notifications);
      setReportNotificationCollection(notificationCollection);
    }
  } catch (error) {
    console.error("Error fetching report notifications I am member of:", error);
  }
};

const loadReportNotifications = (reportNotificationViewTypeId) => {
  setSelectedReportNotificationTypeId(reportNotificationViewTypeId);
  switch (parseInt(reportNotificationViewTypeId)) {
    case 1:
      // My subscriptions
      setIsReportNotificationTypeSelected(true);
      // Implement getReportNotificationByUser(selectedTenantId, selectedUserId) in React and call here
       getReportNotificationByUser(selectedTenantId, selectedUserId);
      break;
    case 2:
      // Subscriptions I am member of
      setIsReportNotificationTypeSelected(true);
      // Implement getReportNotificationsIAmMemberOf in React and call here
       fetchReportNotificationsIAmMemberOf(selectedTenantId, selectedUserId);
      break;
    case 3:
      // Subscription Report
      setIsReportNotificationTypeSelected(true);
      getTenantInfoById(selectedTenantId);
      break;
    default:
      setSelectedReportNotificationTypeId("0");
      setIsReportNotificationTypeSelected(false);
      break;
  }
};

const getReportNotificationByUser = async (tenantId, userId) => {
  setLoading(true);
  setShowReportNotifications(true);
  setReportNotifications([]);
  setReportNotificationCollection([]);
  setShowUsers(true);
  try {
    const result = await getReportNotificationListByUser(tenantId, userId);
    if (result && result.data && (result.data.length !== 0 || result.data !== undefined)) {
      setShowReportNotifications(true);
      setReportNotifications(result.data);
      // Ensure each row has a unique id property
      const processedRows = result.data.map(row => ({
        ...row,
        // Normalize field names to match grid column expectations
        DisplayName: row.displayName ?? row.DisplayName,
        CreatedBy: row.createdBy ?? row.CreatedBy,
        CreatedDate: row.createdDate ?? row.CreatedDate,
        LastModifiedBy: row.lastModifiedBy ?? row.LastModifiedBy,
        LastModifiedDate: row.lastModifiedDate ?? row.LastModifiedDate,
        ReportFormat: row.reportFormat ?? row.ReportFormat,
        ToEmailAddresses: row.toEmailAddresses ?? row.ToEmailAddresses,
        Timezone: row.timezone ?? row.Timezone,
        StartDate: row.startDate ?? row.StartDate,
        EndDate: row.endDate ?? row.EndDate,
        RecurrencePattern: row.recurrencePattern ?? row.RecurrencePattern,
        RecurrencePatternDetails: row.recurrencePatternDetails ?? row.RecurrencePatternDetails,
        SendReportTime: row.sendReportTime ?? row.SendReportTime,
        NextRecurrenceDate: row.nextRecurrenceDate ?? row.NextRecurrenceDate,
        EmailBodyTemplate: row.emailBodyTemplate ?? row.EmailBodyTemplate,
        FullReport: row.fullReport ?? row.FullReport,
        TemplateId: row.templateId ?? row.TemplateId,
        TenantId: row.tenantId ?? row.TenantId,
        UserId: row.userId ?? row.UserId,
        SubscriptionID: row.subscriptionID ?? row.id ?? uuidv4(),
        Subject: row.subject ?? row.Subject,
        RLSUser: row.rlsUser ?? row.RLSUser,
        ReportShareType: row.reportShareType ?? row.ReportShareType,
        ReportPassword: row.reportPassword ?? row.ReportPassword,
        Properties: row.properties ?? row.Properties,
        ObjectId: row.objectId ?? row.ObjectId,
        LastDeliveryStatus: row.lastDeliveryStatus ?? row.LastDeliveryStatus,
        DeviceType: row.deviceType ?? row.DeviceType,
        id: row.subscriptionID ?? row.id ?? uuidv4()
      }));
      setReportNotificationCollection(processedRows);
      const { notifications, notificationCollection } = getFeatureName(
        processedRows,
        [...processedRows],
        HvaObjects
      );
      setReportNotifications(notifications);
      setReportNotificationCollection(notificationCollection);
    }
  } catch (error) {
    console.error("Error fetching report notifications by user:", error);
  } finally {
    setLoading(false);
  }
};
const handleRowManage = async (id, rowdata, action = 'manage') => {
   if (action === 'manage') {  
          setSelectedSubscription(rowdata);  
          setOpenConfigureDialog(true);  
          return;  
      }
}

 const handleRowUpdate = async (id, rowdata) => {
      let tempObjectId = rowdata.objectId;
      if (tempObjectId !== null && tempObjectId !== undefined && tempObjectId !== "") {
        const feature = HvaObjects.filter(e => e.ObjectId === tempObjectId);
        if (feature.length === 0) {
          window.alert("Feature not found for the selected subscription.");
          return;
        }
    }
      if (users.length === 0 && selectedTenantId) {
      try {
        const result = await getAllUsers(selectedTenantId, true);
        if (result && result.data) {
          setUsers(result.data);
          setTempUsers(result.data);
          // You can use newReportNotificationObject as needed here
        }
           
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    }
      setNewReportNotificationObject(rowdata);
      setSubcriptionMgtActionType("edit");
      setOpenSubscriptionDialog(true);

    };

    const handleConfirmDelete = (data) => {
        // Implement delete logic here
        setNewReportNotificationObject(data);
        setSubcriptionMgtActionType("delete");
        setOpenSubscriptionDialog(true);
    };

    const handlePopupView = (data) => {
        // Implement popup view logic here
        // console.log("Popup view data:", data.SubscriptionID);
        setSelectedScheduleRow(data);
        setOpenSchedulePopup(true);
    };
  const handleNewSubscription = async () => {
    setSubcriptionMgtActionType("add");
    setOpenSubscriptionDialog(true);

    // Set default timezone if not present
    if (!userType.timezone || userType.timezone === null || userType.timezone === '') {
      userType.timezone = 'Eastern Standard Time';
    }
    // If users list is empty, fetch users and create newReportNotificationObject
    if (users.length === 0 && selectedTenantId) {
      try {
        const result = await getAllUsers(selectedTenantId, true);
        if (result && result.data) {
          setUsers(result.data);
          setTempUsers(result.data);
          // You can use newReportNotificationObject as needed here
        }
           
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    } else if (users.length > 0) {
      // Find user by selectedUserId in users array
      const foundUser = users.find(e => e.UserId === selectedUserId);
      setTempUsers(foundUser);
      // Use foundUser as needed
  }

  // Create newReportNotificationObject using React state/props
          setNewReportNotificationObject({
            TenantId: selectedTenantId,
            UserId: userId,
            ObjectId: '',
            TemplateId: 1,
            ToEmailAddresses: '',
            CcEmailAddresses: '',
            Subject: '',
            ReportShareType: 2,
            ReportFormat: '',
            FullReport: true,
            ReportPassword: '',
            RecurrencePattern: 'Daily',
            RecurrencePatternDetails: 'EveryDay',
            StartDate: '',
            EndDate: '',
            SendReportTime: '',
            NextRecurrenceDate: '',
            Timezone: userType.timezone,
            DeviceType: '',
            LastDeliveryStatus: '',
            CreatedBy: currentUserEmailId,
            DisplayName: '',
            EmailBodyTemplate: '',
            LastModifiedBy: ''
          });
};

// Callback to handle SubscriptionMgt CRUD operations
const handleSubscriptionMgtAction = async (actionType, subscriptionObj) => {
  switch (actionType) {
    case 'add':
      // TODO: Call API to add subscription
      console.log('Add subscription:', subscriptionObj);
      addReportNotification(subscriptionObj).then(response => {
        setOpenSubscriptionDialog(false);
        //console.log('Subscription added successfully:', response.data);
        loadReportNotifications(selectedNotification);
        // Optionally update local state or refetch data
      });
      break;
    case 'edit':
      // TODO: Call API to update subscription
      console.log('Edit subscription:', subscriptionObj);
      updateReportNotification(subscriptionObj).then(response => {
        setOpenSubscriptionDialog(false);
        //console.log('Subscription updated successfully:', response.data);
        loadReportNotifications(selectedNotification);
        // Optionally update local state or refetch data
      });
      // Optionally update local state or refetch data
      break;
    case 'delete':
      console.log('Delete subscription:', subscriptionObj);
      try {
        const tenantId = subscriptionObj.TenantId ;
        const subscriptionId = subscriptionObj.SubscriptionID;
        const featureId = subscriptionObj?.ObjectId ?? subscriptionObj?.FeatureId ?? '';
        if (!tenantId || !subscriptionId) {
          console.error('Missing tenantId or subscriptionId for delete');
          return;
        }
        deleteReportNotification(tenantId, subscriptionId, featureId).then(response => {
          // Remove from grid state
          const idToRemove = subscriptionObj.SubscriptionID ?? subscriptionObj.id;
          setReportNotificationCollection((prev) => prev.filter(r => (r.SubscriptionID ?? r.id) !== idToRemove));
          setReportNotifications((prev) => prev.filter(r => (r.SubscriptionID ?? r.id) !== idToRemove));
          setOpenSubscriptionDialog(false);
        }).catch(error => {
          console.error('Error deleting subscription', error);
        });
      } catch (error) {
        console.error('Error deleting subscription', error);
      }
      break;
    default:
      console.warn('Unknown actionType:', actionType);
  }
};

function showEditButton(reportNotification, selectedReportNotificationTypeId, userId, isTenantAdmin, isServiceAdmin, isSupportImplUser) {
  switch (parseInt(selectedReportNotificationTypeId)) {
    case 1:
      // My subscriptions
      if ((reportNotification.UserId === userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
        return true;
      }
      break;
    case 2:
      // Subscriptions I am member of
      return false;
    case 3:
      // Subscription Report
      if ((reportNotification.UserId === userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
        return true;
      }
      break;
    default:
      return false;
  }
};

 function showDeleteButton( reportNotification,
  selectedReportNotificationTypeId,
  userId,
  isTenantAdmin,
  isServiceAdmin,
  isSupportImplUser) {
    switch (parseInt(selectedReportNotificationTypeId)) {
        case 1:
            // My subscriptions

            if ((reportNotification.UserId == userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
                return true;
            }

            break;
        case 2:
            // Subscriptions I am member of
            return false;
        case 3:
            // Subscription Report
            if ((reportNotification.UserId == userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
                return true;
            }

            break;
    }
};

 const handleConfigureSave = async (updatedSubscription, filters) => {  
    try {  
      await updatePropertiesReportNotification({  
        reportNotification: updatedSubscription  
      });  
        
      if (filters.length > 0) {  
        await updateReportNotificationObjectFilters(filters);  
      }  
        
      loadReportNotifications(selectedNotification);  
    } catch (error) {  
      console.error('Error saving configuration:', error);  
    }  
  }; 

function showEditButton(reportNotification, selectedReportNotificationTypeId, userId, isTenantAdmin, isServiceAdmin, isSupportImplUser) {
  switch (parseInt(selectedReportNotificationTypeId)) {
    case 1:
      // My subscriptions
      if ((reportNotification.UserId === userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
        return true;
      }
      break;
    case 2:
      // Subscriptions I am member of
      return false;
    case 3:
      // Subscription Report
      if ((reportNotification.UserId === userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
        return true;
      }
      break;
    default:
      return false;
  }
};

 function showDeleteButton( reportNotification,
  selectedReportNotificationTypeId,
  userId,
  isTenantAdmin,
  isServiceAdmin,
  isSupportImplUser) {
    switch (parseInt(selectedReportNotificationTypeId)) {
        case 1:
            // My subscriptions

            if ((reportNotification.UserId == userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
                return true;
            }

            break;
        case 2:
            // Subscriptions I am member of
            return false;
        case 3:
            // Subscription Report
            if ((reportNotification.UserId == userId) || isTenantAdmin || isServiceAdmin || isSupportImplUser) {
                return true;
            }

            break;
    }
};

// Utility function to determine if the Subscribe button should be shown
function showSubscribeButton(
  reportNotification,
  selectedReportNotificationTypeId,
  userId,
  currentUserEmailId,
  isTenantAdmin,
  isServiceAdmin,
  isSupportImplUser
) {
  // Removed console.log to prevent excessive calls and logging
  switch (Number(selectedReportNotificationTypeId)) {
    case 1:
      return false;
    case 2:
      return false;
    case 3: {
      const toEmails =
        Array.isArray(reportNotification.ToEmailAddresses)
          ? reportNotification.ToEmailAddresses
          : typeof reportNotification.ToEmailAddresses === 'string'
            ? reportNotification.ToEmailAddresses.split(',').map(e => e.trim())
            : [];
      return (
        (reportNotification.UserId !== userId &&
          !toEmails.includes(currentUserEmailId)) ||
        isTenantAdmin ||
        isServiceAdmin ||
        isSupportImplUser
      );
    }
    default:
      return false;
  }
}

function showUnsubscribeButton(
  reportNotification,
  selectedReportNotificationTypeId,
  userId,
  currentUserEmailId,
  isTenantAdmin,
  isServiceAdmin,
  isSupportImplUser
) {
  switch (Number(selectedReportNotificationTypeId)) {
    case 1:
      // My subscriptions
      return false;
    case 2:
      // Subscriptions I am member of
         const toEmails =
          Array.isArray(reportNotification.ToEmailAddresses)
            ? reportNotification.ToEmailAddresses
            : typeof reportNotification.ToEmailAddresses === 'string'
              ? reportNotification.ToEmailAddresses.split(',').map(e => e.trim())
              : [];
        if (
          reportNotification.UserId !== userId ||
          toEmails.includes(currentUserEmailId) ||
          isTenantAdmin ||
          isServiceAdmin ||
          isSupportImplUser
        ) {
          return true;
        } 
        return false;
    case 3:
      // Subscription Report
      return false;
    default:
      return false;
  }
}

const handleSubscribe = async (data) => {
  try {
    
    const result = await subscribeReportNotification(data);
    // console.log("Subscribe result:", result);
    if (result?.data?.length !== 0 || result?.data !== undefined) {
      // alert("Report Subscribe request has been sent to the Subscription owner.");
      setSubscribeAlert({  
        open: true,  
        message: "Report Subscribe request has been sent to the Subscription owner.",  
        severity: 'success'  
      });
    }

  } catch (error) {
    // alert("Error occurred while sending Report Subscribe request to the Subscription owner.");
    setSubscribeAlert({  
      open: true,  
      message: "Error occurred while sending Report Subscribe request to the Subscription owner.",  
      severity: 'error'  
    }); 
  }
}

const handleUnsubscribe = async (data) => {
   try {
    const result = await unsubscribeReportNotification(data);

    if (result?.data?.length !== 0 || result?.data !== undefined) {
      // React version of $scope.LoadReportNotifications(...)
      loadReportNotifications(selectedReportNotificationTypeId);
      // alert(`You are unsubscribed from the Report Subscription ${data.DisplayName}.`);
      setSubscribeAlert({  
        open: true,  
        message: `You are unsubscribed from the Report Subscription ${data.DisplayName}.`,  
        severity: 'success'  
      });
    }

  } catch (error) {
    // alert(`Error occurred while Unsubscribing from the Report Subscription ${data.DisplayName}.`);
    setSubscribeAlert({  
      open: true,  
      message: `Error occurred while Unsubscribing from the Report Subscription ${data.DisplayName}.`,  
      severity: 'error'  
    });  
  }
}
  return (
    <Box sx={{ p: 2, height: 'calc(92vh - 100px)',display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* <Typography variant="h6" sx={{ mb: 2 }}>Subscription Management</Typography> */}
      <Snackbar  
        open={subscribeAlert.open}  
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
        sx={{ mt: 8 }} // Adjust top margin to appear below header  
      >  
        <Alert  
          severity={subscribeAlert.severity}  
          action={  
            <>  
              <Button  
                size="small"  
                onClick={() => setSubscribeAlert({ ...subscribeAlert, open: false })}  
                sx={{ color: 'inherit' }}  
              >  
                OK  
              </Button>   
            </>  
          }  
        >  
          {subscribeAlert.message}  
        </Alert>  
      </Snackbar>
      <Box sx={{ border: '1px solid #ccc', borderRadius: 2, p: 2,  bgcolor: '#fafafa', width: '95vw', maxWidth: '100%', height: 'calc(87vh - 90px)', overflowY: 'hidden' }}>
        <FormControl sx={{ ml: 1, minWidth: 250 }} size="medium">
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography className="lableFontBold" title="Reports" sx={{ verticalAlign: 'middle', mr: 2, pt: 0.5 }}>
              Reports Notification Types:
            </Typography>
            <InputLabel id="lblNotificationType" sx={{ display: 'none' }}>Notification</InputLabel>
            <Select
              labelId="lblNotificationType"
              id="tenant-select"
              value={selectedNotification}
              onChange={e => {
                setSelectedNotification(e.target.value);
                loadReportNotifications(e.target.value);
              }}
              sx={{ height: 30, bgcolor: 'white', minWidth: 250 }}
              disabled={disableReportNotificationTypeList}
            >
              {notifications.map((notification, idx) => (
                <MenuItem key={getNotificationValue(notification, idx)} value={getNotificationValue(notification, idx)}>
                  {notification.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </FormControl>
        {/* Only show the link button if showNewNotificationLink is true and user has Manage privilege or is admin/support */}
        {showNewNotificationLink  && (
          <Box sx={{ mt: 1, marginLeft: '195px' }}>
            <Link underline="hover" component="button" fontWeight={600}
              variant="body2"
              onClick={handleNewSubscription}
            >
              New Subscription
            </Link>
          </Box>
        )}
        <Dialog 
          open={openSubscriptionDialog} 
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              setOpenSubscriptionDialog(false);
            }
          }} 
          maxWidth="md" 
          fullWidth
          PaperProps={{ sx: { p: 1 } }}
        >
          <DialogContent sx={{ p: 0 }}>
            <SubscriptionMgt 
              onClose={() => setOpenSubscriptionDialog(false)} 
              isAuthenticated={isAuthenticated}
              userType={userType}
              actionType= {subcriptionMgtActionType}
              users={Array.isArray(tempUsers) && tempUsers.length > 0 ? tempUsers : Array.isArray(users) ? users : []}
              reportNotificationObject={newReportNotificationObject}
              hvaObjects={Array.isArray(HvaObjects) ? HvaObjects : []}
              tenantEmailBodyTemplates={Array.isArray(tenantEmailBodyTemplates) ? tenantEmailBodyTemplates : []}
              featureNames={objectName}
              isServiceOrTenantAdminOrSupportImpUser={isServiceOrTenantAdminOrSupportImpUser}
              onSubscriptionAction={handleSubscriptionMgtAction}
              openSubscriptionDialog = {openSubscriptionDialog}
              resetSessionTimer={resetSessionTimer}
            />
          </DialogContent>
        </Dialog>
        {/* Only show the link button if IsReportNotificationTypeSelected is true */}
      { isReportNotificationTypeSelected && (
        <Box sx={{ mt: 1 }}>
          <Typography className="lableFontBold" sx={{ verticalAlign: 'middle', mr: 2, pt: 0.5, fontWeight: 600 }}>
            Existing subscription list
          </Typography>
          {loading ? (
            <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>Loading...</Typography>
          ) : (
            <InDataGridContainer
              // autoHeight
              apiRef={apiRef}
              rows={Array.isArray(reportNotificationCollection) ? reportNotificationCollection : []}
              setRows={setReportNotificationCollection}
              columns={columns}
              getRowId={(row) => row.SubscriptionID || row.id}
              editable
              onDelete={handleConfirmDelete}
              editMode="row"
              onPopupViewClick={handlePopupView}
              onRowEdit={handleRowUpdate}
              onRowManage={handleRowManage}
              onSubscribe={handleSubscribe}
              onUnsubscribe={handleUnsubscribe}
              isSubscribedEnabled={(row) =>
                showSubscribeButton(
                  row,
                  selectedReportNotificationTypeId,
                  selectedUserId,
                  currentUserEmailId,
                  props.isTenantAdmin,
                  props.isServiceAdmin,
                  props.isSupportImplUser
                )
              }
              isUnsubscribedEnabled={(row) =>
                showUnsubscribeButton(
                  row,
                  selectedReportNotificationTypeId,
                  selectedUserId,
                  currentUserEmailId,
                  props.isTenantAdmin,
                  props.isServiceAdmin,
                  props.isSupportImplUser
                )
              }
              showEditButton={(row) =>
                showEditButton(
                  row,
                  selectedReportNotificationTypeId,
                  selectedUserId,
                  props.isTenantAdmin,
                  props.isServiceAdmin,
                  props.isSupportImplUser
                )
              }
              showDeleteButton={(row) =>
                showDeleteButton(
                  row,
                  selectedReportNotificationTypeId,
                  selectedUserId,
                  props.isTenantAdmin,
                  props.isServiceAdmin,
                  props.isSupportImplUser
                )
              }
              showManageButton={(row) =>
                showEditButton(
                  row,
                  selectedReportNotificationTypeId,
                  selectedUserId,
                  props.isTenantAdmin,
                  props.isServiceAdmin,
                  props.isSupportImplUser
                )
              }
            />
          )}
        </Box>
      )}
       {/* Configure Content Pack Dialog */}  
           <ConfigureContentPack  
            open={openConfigureDialog}  
            onClose={() => setOpenConfigureDialog(false)}  
            subscription={selectedSubscription}  
            tenantId={selectedTenantId}  
            onSave={handleConfigureSave}  
          /> 
      <ScheduleViewDialog
          open={openSchedulePopup}
          onClose={() => setOpenSchedulePopup(false)}
          data={selectedScheduleRow}/>
      </Box>
    </Box>
  );
}

export default SubscriptionMgtMain;